import { styled } from '@glitz/react';

// Grey tones, from white to black
export const white = '#FFFFFF';
export const softWhite = '#F3F3F3';
export const grey = '#E3E3E3';
export const secondaryGrey = '#E3DFDC';
export const shadedGrey = '#C1C1C1';
export const darkGrey = '#7E7E7E';
export const paleBlack = '#4D4D4D';
export const tintedBlack = '#222222';
export const black = '#000000';
export const a11yGrey = '#767676';
export const a11yGreyDarker = '#696969';
export const greenText = '#1E865C';

//Accent colors
export const orange = '#D78000'; //used for ratings
export const green = '#35AE7D'; //used for in stock
export const red = '#EF4B00'; //used for out of stock

export const sharedSpacing = { xxxxl: 70, xxxl: 56, xxl: 40, xl: 32, l: 24, m: 16, s: 12, xs: 8, xxs: 4 };

export const sharedFontSize = { xxxl: 42, xxl: 30, xl: 25, l: 20, m: 18, s: 16, xs: 14, xxs: 12, xxxs: 10 };

export const srOnlyDecorator = styled({
  position: 'absolute',
  width: 1,
  height: 1,
  margin: { xy: -1 },
  border: { xy: { style: 'none', width: 0 } },
  padding: { xy: 0 },
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
});
